export default "__VITE_ASSET__dnLA_27B__"